import type { ReactNode } from "react";
import ErrorPanel from "../../../../../components/common/ErrorPanel/ErrorPanel";
import type { ConnectionHubError } from "../../../api/connectionHub.types";
import { connectionErrorContent } from "../../../constants/connectionErrorCodes";

export interface ConnectionErrorPanelProps {
  /** A caught hub error, or a message the server handed us with no code behind it. */
  error: ConnectionHubError | string | null | undefined;
  /** Omit for the default contact line; pass null to drop it. */
  note?: ReactNode;
  className?: string;
}

/** Maps a hub error onto the shared panel so the same failure reads the same on every screen. */
export const ConnectionErrorPanel = ({ error, note, className }: ConnectionErrorPanelProps): JSX.Element | null => {
  if (!error) return null;
  const { title, description } = connectionErrorContent(error);
  return (
    <ErrorPanel
      title={title}
      description={description}
      {...(note === undefined ? {} : { note })}
      {...(className ? { className } : {})}
    />
  );
};

export default ConnectionErrorPanel;
